import { Button, Separator, Stack, Text, useDisclosure } from "@chakra-ui/react";
import { Form, Parts, UI } from "components"
import { useState } from "react";
import OneSignal from "react-onesignal"

export default function Notifications(){

    const dialog = useDisclosure()
    const [ loading, setLoading ] = useState()
    const optedIn = OneSignal.User.PushSubscription.optedIn

    const toggleOptIn = async () => {
        setLoading(true)
        optedIn ? await OneSignal.User.PushSubscription.optOut() : await OneSignal.User.PushSubscription.optIn()
        setLoading(false)
    }

    return(
    <>
    <Parts.Dialog.Notification {...dialog} />
    <UI.Box>
        <Stack gap={4}>
            <Text color="GrayText">Notificações:</Text>

            <UI.Lottie animation="notification" options={{ loop: true }} style={{ height: '180px', transform: 'scale(1.2)' }} />
        
            <UI.Show visible={!OneSignal.Notifications.permission}>    
                <Button colorPalette="orange" onClick={dialog.onOpen}><UI.Icon name="notification" /> Ativar notificações</Button>
            </UI.Show>

            <UI.Show visible={OneSignal.Notifications.permission}>    
                <Button disabled colorPalette="orange" onClick={dialog.onOpen}><UI.Icon name="check" /> Notificações ativadas</Button>
            </UI.Show>

            <Separator />

            <Form.Checkbox disabled={loading} colorPalette="orange" defaultChecked={optedIn} onChange={toggleOptIn} label="Receber notificações de novidades e promoções." />
        </Stack>
    </UI.Box>
    </>
    )
}